<template>
    <div>
        <div class="entry-info_item">
            <span class="label small-caps">Unlock Order:</span>
            <span class="value cursor-pointer" @click="applyChange()">
                <checkbox_empty v-if="unlock_order == 0"></checkbox_empty>
                <checkbox_checked v-else-if="unlock_order == 1"></checkbox_checked>
                Yes
            </span>
        </div>
    </div>
</template>

<script>
    import modal from '../components/Modal.vue';
    import itemTemplate from '../components/ItemTemplate.vue';
    import Checkbox_empty from "./icons/checkbox_empty";
    import Checkbox_checked from "./icons/checkbox_checked";

    export default {
        components: {Checkbox_checked, Checkbox_empty, modal},
        props: ['order_id', 'action_url_update', 'lock_status'],
        data() {
            return {
                unlock_order: this.lock_status,
            }
        },
        methods: {
            changeUserModal: function() {
                this.modalTrigger = true;
            },
            applyChange: function() {
                let that = this;
                window.axios(
                    {
                        method: 'PUT',
                        url: that.action_url_update,
                        params: {
                            unlock: (that.unlock_order == 0) ? 1 : 0,
                        }
                    }).then(function(response) {
                        window.location.reload();
                }).catch(function (error) {
                    // handle error
                    console.log('This is the error returned', error);
                });
            },
        }
    }
</script>
